import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { LoginPageComponent } from './login-page.component';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent, data: { title: extract('Login') } },
  { path: 'login/new', component: LoginPageComponent, data: {
        title: extract('Cadastro'),
        isNew: true
      }
  },
  { path: 'login/new', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/login-page/login-page-routing.module.ts